import{createResponsiveConnect}from"@team-griffin/react-matchmedia-connect";var breakpoints={xs:0,sm:576,md:768,lg:992,xl:1200},breakpointConnect=createResponsiveConnect(breakpoints);export{breakpoints,breakpointConnect};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ux/responsive/dist/es/responsive.production.js
// module id = 1388
// module chunks = 0